import { combineReducers } from 'redux-immutable'
import masterDataGetReducer from './master-data-get-reducer'

export default combineReducers({
  masterDataGet: masterDataGetReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/master-data/index.js